import { c as _c } from "react/compiler-runtime";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { useDropForgeManifoldClaim } from "@/hooks/useDropForgeManifoldClaim";
import type { ManifoldClaimStatus } from "@/hooks/useManifoldClaim";
import { useNowMinting } from "@/hooks/useNowMinting";
type NowMintingStatus = {
  readonly nft: NFTWithMemesExtendedData | undefined;
  readonly isFetching: boolean;
  readonly status: ManifoldClaimStatus | null;
  readonly isStatusLoading: boolean;
  readonly error: unknown;
};
export const useNowMintingStatus = () => {
  const $ = _c(6);
  const {
    nft,
    isFetching,
    error
  } = useNowMinting();
  const {
    claim
  } = useDropForgeManifoldClaim(nft?.id ?? -1);
  const t0 = claim?.status ?? null;
  const t1 = !!nft && !claim;
  let t2;
  if ($[0] !== error || $[1] !== isFetching || $[2] !== nft || $[3] !== t0 || $[4] !== t1) {
    t2 = {
      nft,
      isFetching,
      status: t0,
      isStatusLoading: t1,
      error
    };
    $[0] = error;
    $[1] = isFetching;
    $[2] = nft;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};